/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} New_End_Time_Last_EventInputs */



/**
* | output |
* | --- |
* | "New end time of last event" |
*
* @param {New_End_Time_Last_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const new_end_time_last_event = /** @type {((inputs?: New_End_Time_Last_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<New_End_Time_Last_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nouvelle fin du dernier événement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neue Endzeit der letzten Veranstaltung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuova ora di fine dell'ultimo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новое время окончания последнего события")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nueva hora de finalización del último evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("上次事件的新结束时间")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最後のイベントの新しい終了時間")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंतिम आयोजन का नया समाप्ति समय")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo horário de término do último evento")
	return /** @type {LocalizedString} */ ("New end time of last event")
});